<template>
  <v-card class="mb-2">
    <v-card-title class="pa-1">
      <v-icon
          :color="iconColor"
          :size="iconSize"
          class="ma-2">{{ titleIcon }}
      </v-icon>
      <span>{{ title }}</span>
      <v-spacer/>
      <v-icon
          v-if="enableEditSectionFlag"
          :color="iconColor"
          :size="iconSize"
          class="mr-3"
          @click="enableEditSection">{{ editIcon }}
      </v-icon>
    </v-card-title>
    <v-card-subtitle v-if="localDescription !== ''"
                     class="my-2"
    >
      {{ localDescription }}
    </v-card-subtitle>
    <v-card-text>
      <tcn-v-jsf-wrapper
          :schema="localSchema"
          :options="options"
          v-model="localModel"
          :section-key="fullKey"
      />

    </v-card-text>
    <v-card-actions
        v-show="editMode"
        class="mt-0, pt-0">
      <v-btn
          color="success"
          style="text-transform: none"
          @click="saveSection"
      >
        Zapisz
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "TcnSection",
  components: {},
  props: {
    value: {default: null},
    options: {type: Object, required: true},
    schema: {type: Object, required: true},
    fullSchema: {type: Object, required: true},
    fullKey: {type: String, required: true},
    label: {type: String, default: ''},
    htmlDescription: {type: String, default: ''},
    disabled: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
    rules: {type: Array, required: true},
    on: {type: Object, required: true},
    rootModel: {type: Object}
  },
  data() {
    return {
      editMode: false,
    }
  },
  computed: {
    localModel: {
      get() {
        return this.rootModel;
      },
      set(val) {
        this.$emit('input', {key: this.fullKey, value: val !== "" ? val : null})
      },
    },

    enableEditSectionFlag() {
      return this.schema['enableEditMode'] !== undefined ? this.schema['enableEditMode'] : true
    },

    title() {
      return this.schema['title'] || "Tytuł sekcji"
    },

    titleIcon() {
      return this.schema['title-icon'] || "mdi-home"
    },

    iconColor() {
      return this.schema['iconColor'] || ""
    },

    iconSize() {
      return this.schema["iconSize"] || 22
    },

    editIcon() {
      return this.schema['edit-icon'] || "mdi-pencil"
    },

    localSchema() {
      return this.schema['items'] || console.log("zdefiniuj schemat jako parametr 'items'")
    },

    workMode() {
      return this.localSchema['workMode'] || "form" //form action
    },

    url() {
      return this.schema['url'] || "brakURL"
    },

    localDescription() {
      return this.schema['description'] || ""
    }
  },
  watch: {},
  methods: {
    saveSection() {
      const data = {}
      data[this.fullKey] = this.localModel
      this.options.httpLib.post(`${this.url}`, data)
          .then((response) => {
            // niech zwraca cały model bo fullKey-em wyciągne to co mnie interere
            this.localModel = response.data[this.fullKey]
          })
          .catch((err) => {
            console.log(err)
          })

    },

    enableEditSection() {
      switch (this.workMode) {
        case "form": {
          this.editFormMode()
          break;
        }
        case "action": {
          const obj = {code: this.localSchema['actionCode']}
          console.log("Emituję w section obiekt", obj)
          this.$emit('resolveAction', obj)
          break;
        }
        default: {
          console.error("Zły tryb 'workMode' - dozwolone: form lub action")
        }
      }
    },

    editFormMode() {
      let keys = Object.keys(this.schema['items'].properties)
      keys.forEach(key => {
        this.schema.items.properties[key].readOnly = !this.schema.items.properties[key].readOnly
        this.editMode = !this.schema.items.properties[key].readOnly
      })

    }
  },
  mounted() {

  }
}
</script>

<style scoped lang="css">

</style>
